module.exports = __webpack_public_path__ + "assets/img/exam1-1.635448fc.png";